import styled from 'styled-components';

import { ButtonProps } from '../types';

export const StyledTextButton = styled.button.attrs<ButtonProps>({
	className: '',
})<ButtonProps>`
	display: flex;
	width: fit-content;
	background: none;
	outline: none;
	border: none;
	color: #0095e8;
	flex-direction: ${(props) =>
		props.contentOrder === 'reverse' ? 'row-reverse' : 'row'};
	justify-content: 'start';
	font-size: ${({ size = 'sm' }) =>
		size === 'sm' ? '14px' : size === 'md' ? '16px' : '19px'};
	padding: ${({ size = 'sm' }) =>
		size === 'sm' ? '5px 10px' : size === 'md' ? '10px 15px' : '15px 20px'};
`;
